import { setGeofenceTypes } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { useMemo } from 'react';
import { FilterableFenceType } from '@customer/store/apis/geofencesApi';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

const useGeofenceTypesOption = (): DropdownItemProps<FilterableFenceType>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return Object.values(FilterableFenceType).map((value: FilterableFenceType) => {
      return {
        key: value,
        value,
        stringValue: value,
        label: t(`GeofenceFenceType.${value}`),
      };
    });
  }, [t]);
};

export const GeofenceTypesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<FilterableFenceType>
      filterName="geofenceTypes"
      label={label ?? t('GeofenceType')}
      action={setGeofenceTypes}
      elementRef={elementRef}
      useItemsHook={useGeofenceTypesOption}
    />
  );
};

export default GeofenceTypesFilter;
